import Accommodation from './singleColor/Accommodation.js';
import ArrowLeft from './singleColor/ArrowLeft.js';
import ArrowRight from './singleColor/ArrowRight.js';
import AttentionCircle from './singleColor/AttentionCircle.js';
import Avatar from './singleColor/Avatar.js';
import Bold from './singleColor/Bold.js';
import BulbGloss from './singleColor/BulbGloss.js';
import Bulb from './singleColor/Bulb.js';
import BulletList from './singleColor/BulletList.js';
import Bus from './singleColor/Bus.js';
import Calendar from './singleColor/Calendar.js';
import Car from './singleColor/Car.js';
import Chat from './singleColor/Chat.js';
import ChatRounded from './singleColor/ChatRounded.js';
import Check from './singleColor/Check.js';
import CheckRounded from './singleColor/CheckRounded.js';
import CheckboxCheck from './singleColor/CheckboxCheck.js';
import CheckCircleHollow from './singleColor/CheckCircleHollow.js';
import CheckCircleSolid from './singleColor/CheckCircleSolid.js';
import ChevronDown from './singleColor/ChevronDown.js';
import ChevronDownRounded from './singleColor/ChevronDownRounded.js';
import ChevronLeft from './singleColor/ChevronLeft.js';
import ChevronUp from './singleColor/ChevronUp.js';
import Clock from './singleColor/Clock.js';
import ChevronRight from './singleColor/ChevronRight.js';
import Close from './singleColor/Close.js';
import CloudUpload from './singleColor/CloudUpload.js';
import Cog from './singleColor/Cog.js';
import Course from './singleColor/Course.js';
import CreditCard from './singleColor/CreditCard.js';
import CrossCircleSolid from './singleColor/CrossCircleSolid.js';
import CvTemplates from './singleColor/CvTemplates.js';
import Cv from './singleColor/Cv.js';
import CvDocument from './singleColor/CvDocument.js';
import Doc from './singleColor/Doc.js';
import Documents from './singleColor/Documents.js';
import Document from './singleColor/DocumentIcon.js';
import Download from './singleColor/Download.js';
import Dots from './singleColor/Dots.js';
import Drag from './singleColor/Drag.js';
import Duplicate from './singleColor/Duplicate.js';
import EmailAgent from './singleColor/EmailAgent.js';
import Envelope from './singleColor/Envelope.js';
import ExclamationMarkCircleSolid from './singleColor/ExclamationMarkCircleSolid.js';
import ExclamationMarkTriangleSolid from './singleColor/ExclamationMarkTriangleSolid.js';
import ExclamationMarkTriangle from './singleColor/ExclamationMarkTriangle.js';
import ExpiringSoon from './singleColor/ExpiringSoon.js';
import EyeInvisible from './singleColor/EyeInvisible.js';
import Facebook from './singleColor/Facebook.js';
import Google from './singleColor/Google.js';
import Eye from './singleColor/Eye.js';
import Hamburger from './singleColor/Hamburger.js';
import History from './singleColor/History.js';
import InfoCircleSolid from './singleColor/InfoCircleSolid.js';
import InfoCircle from './singleColor/InfoCircle.js';
import Insert from './singleColor/Insert.js';
import Instagram from './singleColor/Instagram.js';
import Italic from './singleColor/Italic.js';
import LinkedIn from './singleColor/LinkedIn.js';
import LockCircleSolid from './singleColor/LockCircleSolid.js';
import LockDocument from './singleColor/LockDocument.js';
import Lock from './singleColor/Lock.js';
import Magnifier from './singleColor/Magnifier.js';
import MagnifierZoom from './singleColor/MagnifierZoom.js';
import Minus from './singleColor/Minus.js';
import Motorbike from './singleColor/Motorbike.js';
import NavClock from './singleColor/NavClock.js';
import NavClockBold from './singleColor/NavClockBold.js';
import NavDocument from './singleColor/NavDocument.js';
import NavDocumentBold from './singleColor/NavDocumentBold.js';
import NavMagnifier from './singleColor/NavMagnifier.js';
import NavMagnifierBold from './singleColor/NavMagnifierBold.js';
import NavStar from './singleColor/NavStar.js';
import NavStarBold from './singleColor/NavStarBold.js';
import NavUser from './singleColor/NavUser.js';
import NavUserBold from './singleColor/NavUserBold.js';
import OrderedList from './singleColor/OrderedList.js';
import Pencil from './singleColor/Pencil.js';
import PencilUnderline from './singleColor/PencilUnderline.js';
import Pin from './singleColor/Pin.js';
import PlusCircle from './singleColor/PlusCircle.js';
import Plus from './singleColor/Plus.js';
import Rotate from './singleColor/Rotate.js';
import SecondarySchool from './singleColor/SecondarySchool.js';
import SpeedRocket from './singleColor/SpeedRocket.js';
import StarFill from './singleColor/StarFill.js';
import StarOutline from './singleColor/StarOutline.js';
import StarSolid from './singleColor/StarSolid.js';
import Stopwatch from './singleColor/Stopwatch.js';
import Talk from './singleColor/Talk.js';
import TelDocument from './singleColor/TelDocument.js';
import Tractor from './singleColor/Tractor.js';
import Translate from './singleColor/Translate.js';
import Transport from './singleColor/Transport.js';
import Trash from './singleColor/Trash.js';
import Truck from './singleColor/Truck.js';
import TruckBig from './singleColor/TruckBig.js';
import TruckTrailer from './singleColor/TruckTrailer.js';
import University from './singleColor/University.js';
import Upload from './singleColor/Upload.js';
import User from './singleColor/User.js';
import UserCircle from './singleColor/UserCircle.js';
import UserSolid from './singleColor/UserSolid.js';
import XTwitter from './singleColor/XTwitter.js';
import CvMulticolor from './multiColor/Cv.js';
import CvNone from './multiColor/CvNone.js';
import IllustrationCheck from './multiColor/IllustrationCheck.js';
import IllustrationReaction from './multiColor/IllustrationReaction.js';
import GoogleMultiColor from './multiColor/GoogleMultiColor.js';
import FacebookMultiColor from './multiColor/FacebookMultiColor.js';
import LinkedInMultiColor from './multiColor/LinkedInMultiColor.js';
import ProfesiaLogo from './multiColor/ProfesiaLogo.js';
import ProfesiaHeaderLogo from './multiColor/ProfesiaHeaderLogo.js';
import ThumbUp from './multiColor/ThumbUp.js';
import UploadCv from './multiColor/UploadCv.js';
import SkFlag from './multiColor/FlagSk.js';
import CzFlag from './multiColor/FlagCz.js';
import EnFlag from './multiColor/FlagEn.js';
import DeFlag from './multiColor/FlagDe.js';
import HuFlag from './multiColor/FlagHu.js';
import UaFlag from './multiColor/FlagUa.js';
import UaFlag24 from './multiColor/FlagUa24.js';
import LtFlag from './multiColor/FlagLt.js';
import EeFlag from './multiColor/FlagEe.js';
import LvFlag from './multiColor/FlagLv.js';
import FiFlag from './multiColor/FlagFi.js';
import HrFlag from './multiColor/FlagHr.js';
import JobAdAlert from './multiColor/JobAdAlert.js';
export { 
//single color
Accommodation, ArrowLeft, ArrowRight, AttentionCircle, Avatar, Bold, BulbGloss, Bulb, BulletList, Bus, Calendar, Car, Chat, ChatRounded, Check, CheckRounded, CheckboxCheck, CheckCircleHollow, CheckCircleSolid, ChevronDown, ChevronDownRounded, ChevronLeft, ChevronUp, ChevronRight, Clock, Close, CloudUpload, Cog, Course, CreditCard, CrossCircleSolid, CvTemplates, Cv, CvDocument, Doc, Documents, Document, Dots, Download, Drag, Duplicate, EmailAgent, Envelope, ExclamationMarkCircleSolid, ExclamationMarkTriangle, ExclamationMarkTriangleSolid, ExpiringSoon, EyeInvisible, Eye, Facebook, Google, Hamburger, History, InfoCircle, InfoCircleSolid, Insert, Instagram, Italic, LinkedIn, Lock, LockCircleSolid, LockDocument, Magnifier, MagnifierZoom, Minus, Motorbike, NavClock, NavClockBold, NavStarBold, NavStar, NavDocument, NavMagnifier, NavDocumentBold, NavMagnifierBold, NavUser, NavUserBold, OrderedList, Pencil, PencilUnderline, Pin, Plus, PlusCircle, Rotate, SecondarySchool, SpeedRocket, StarFill, StarOutline, StarSolid, Stopwatch, Talk, TelDocument, Tractor, Translate, Transport, Trash, Truck, TruckBig, TruckTrailer, University, Upload, User, UserCircle, UserSolid, XTwitter, 
//multi color
CvMulticolor, CvNone, IllustrationCheck, IllustrationReaction, GoogleMultiColor, FacebookMultiColor, LinkedInMultiColor, ProfesiaLogo, ProfesiaHeaderLogo, ThumbUp, UploadCv, SkFlag, CzFlag, EnFlag, DeFlag, HuFlag, UaFlag, UaFlag24, LtFlag, EeFlag, LvFlag, FiFlag, HrFlag, JobAdAlert, };
